module.exports = __webpack_public_path__ + "img/ac68f25.jpg";